"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link SetSessionPropertiesFilterRequest}
 */
var SetSessionPropertiesFilterRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(SetSessionPropertiesFilterRequestSerialiserClass, _super);
    function SetSessionPropertiesFilterRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link SetSessionPropertiesFilterRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link SetSessionPropertiesFilterRequest} to be written
     */
    SetSessionPropertiesFilterRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.filter);
        if (Object.keys(value.overwriteProperties).length === 0) {
            Codec.writeByte(bos, 0);
        }
        else {
            Codec.writeByte(bos, 1);
            Codec.writeDictionary(bos, value.overwriteProperties, Codec.writeString);
        }
        if (Object.keys(value.removeProperties).length === 0) {
            Codec.writeByte(bos, 0);
        }
        else {
            Codec.writeByte(bos, 1);
            Codec.writeCollection(bos, value.removeProperties, Codec.writeString);
        }
    };
    return SetSessionPropertiesFilterRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SetSessionPropertiesFilterRequestSerialiserClass = SetSessionPropertiesFilterRequestSerialiserClass;
/**
 * The {@link SetSessionPropertiesFilterRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SetSessionPropertiesFilterRequestSerialiser = new SetSessionPropertiesFilterRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/set-session-properties-filter-request-serialiser.js
// module id = 1284
// module chunks = 1